import React from 'react';

function doug() {
    return(
        <>
            <section id="crew-container">
                <h2 id="crew-title">
                    COMMANDER
                </h2>
                <h3 id="crew-name">
                    DOUGLAS HURLEY
                </h3>
                <p id="information" className="crew-info">
                    Douglas Gerald Hurley is an American engineer, former Marine Corps pilot and former NASA 
                    astronaut. He launched into space for the third time as commander of Crew Dragon Demo-2.
                </p>
            </section>
        </>
    );
}

export default doug;